export default ["$locale", "DemoModeService", "ConfigService","LocaleService", function ($locale, DemoModeService, ConfigService,LocaleService) {

  function formatMoney(a, _c, _d, _t) {
    var n = a;
    var c, d, t, s, i, j;

    c = isNaN(c = Math.abs(_c)) ? 2 : c;
    d = _d === undefined ? "." : _d;
    t = _t === undefined ? "," : _t;

    s = n < 0 ? "-" : "";
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;

    return "\u00A4 " + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  }

  return function (money, nullable, currencySymbol, fractionSize) {

    //var formats = $locale.NUMBER_FORMATS;

    if (ConfigService.get("localCurrency", true)) {
      currencySymbol = ConfigService.get("localCurrency", true);
    }

    var amount; // = 0;

    if (DemoModeService.isDemoModeEnabled()) {
      return "**.***,**";
    }
    else {

      if (money && money.value) {
        amount = money.value;
        currencySymbol = money.currency.code || currencySymbol;

      }
      else {
        if (!nullable) {
          amount = 0;
        }
        else {
          return null;
        }
      }

      if (angular.isUndefined(currencySymbol)) {
        currencySymbol = "EUR" || LocaleService.getCurrencySymbol();
      }

      if (angular.isUndefined(fractionSize)) {
        fractionSize =  LocaleService.getFractionSize();
      }

      if (currencySymbol == "EUR") {
        currencySymbol = "€";
      }

      if (currencySymbol == "USD") {
        currencySymbol = "$";
      }

      // if null or undefined pass it through
      return (amount === null) ? amount : formatMoney(amount, fractionSize, LocaleService.getDecimalSeparator(),LocaleService.getThousandsSeparator()).replace(/\u00A4/g, currencySymbol);
    }

  };
}];



// WEBPACK FOOTER //
// ./src/ui/app/filter/money.js